import DActivityFeed from '@d-components/d-activity-feed/d-activity-feed.vue';
import DActivitySingle from '@d-components/d-activity-single/d-activity-single.vue';
import DBackButton from '@d-components/d-back-button/d-back-button.vue';
import DBlogOutScreen from '@d-components/d-blog-out-screen/d-blog-out-screen.vue';
import DBookActivityFeed from '@d-components/d-book-activity-feed/d-book-activity-feed.vue';
import DBookBottomActions from '@d-components/d-book-bottom-actions/d-book-bottom-actions.vue';
import DBookBuyButton from '@d-components/d-book-buy-button/d-book-buy-button.vue';
import DBookChapter from '@d-components/d-book-chapter/d-book-chapter.vue';
import DBookCommentsCount from '@d-components/d-book-comments-count/d-book-comments-count.vue';
import DBookGallery from '@d-components/d-book-gallery/d-book-gallery.vue';
import DBookReviewActions from '@d-components/d-book-review-actions/d-book-review-actions.vue';
import DBookSubmissionMinDate from '@d-components/d-book-submission-min-date/d-book-submission-min-date.vue';
import DBookSynopsis from '@d-components/d-book-synopsis/d-book-synopsis.vue';
import DBookUpdatesCount from '@d-components/d-book-updates-count/d-book-updates-count.vue';
import DBookUserReviewsCount from '@d-components/d-book-user-reviews-count/d-book-user-reviews-count.vue';
import DBookUserReviewAuthor from '@d-components/d-book-user-reviews-list/d-book-user-review-entry/d-book-user-review-author/d-book-user-review-author.vue';
import DBookUserReviewsList from '@d-components/d-book-user-reviews-list/d-book-user-reviews-list.vue';
import DBookUserReviewsOverall from '@d-components/d-book-user-reviews-overall/d-book-user-reviews-overall.vue';
import DBookVoteButton from '@d-components/d-book-vote-button/d-book-vote-button.vue';
import DBookWriteUserReviewPanel from '@d-components/d-book-write-user-review-panel/d-book-write-user-review-panel.vue';
import DCommentsPanel from '@d-components/d-comments-panel/d-comments-panel.vue';
import DDiscoverFeed from '@d-components/d-discover-feed/d-discover-feed.vue';
import DFollowersList from '@d-components/d-followers-list/d-followers-list.vue';
import DLeaderboardFeed from '@d-components/d-leaderboard-feed/d-leaderboard-feed.vue';
import DProfileBadge from '@d-components/d-profile-badges/d-profile-badge/d-profile-badge.vue';
import DProfileBookshelfList from '@d-components/d-profile-bookshelf-list/d-profile-bookshelf-list.vue';
import DProfileDirectSubmissions from '@d-components/d-profile-direct-submissions/d-profile-direct-submissions.vue';
import DProfileExpandableBiography from '@d-components/d-profile-expandable-biography/d-profile-expandable-biography.vue';
import DReviewerDirectory from '@d-components/d-reviewer-directory/d-reviewer-directory.vue';
import DStickyMenu from '@d-components/d-sticky-menu/d-sticky-menu.vue';
import DStickyMenuSaveToLibrary from '@d-components/d-sticky-menu-save-to-library/d-sticky-menu-save-to-library.vue';
import DTopMenuContainer from '@d-components/d-top-menu-container/d-top-menu-container.vue';
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';
import DSignupButton from '@d-shared/components/d-signup-button/d-signup-button.vue';
import DTrackingLink from '@d-shared/components/d-tracking-link/d-tracking-link.vue';
import DAdminExitModal from '@d-shared/components/exit-modals/d-admin-exit-modal/d-admin-exit-modal.vue';
import DBookExitModal from '@d-shared/components/exit-modals/d-book-exit-modal/d-book-exit-modal.vue';
import DDefaultExitModal from '@d-shared/components/exit-modals/d-default-exit-modal/d-default-exit-modal.vue';

import DFormRecaptcha from './d-form-recaptcha/d-form-recaptcha.vue';
import DGenresSignupForm from './d-genres-signup-form/d-genres-signup-form.vue';

export default {
  DActivityFeed,
  DActivitySingle,
  DAdminExitModal,
  DBackButton,
  DBlogOutScreen,
  DBookActivityFeed,
  DBookExitModal,
  DBookBottomActions,
  DBookBuyButton,
  DBookChapter,
  DBookCommentsCount,
  DDefaultExitModal,
  DBookGallery,
  DBookReviewActions,
  DBookSubmissionMinDate,
  DBookSynopsis,
  DBookUpdatesCount,
  DBookUserReviewAuthor,
  DBookUserReviewsCount,
  DBookUserReviewsList,
  DBookUserReviewsOverall,
  DBookVoteButton,
  DBookWriteUserReviewPanel,
  DCommentsPanel,
  DDiscoverFeed,
  DFollowersList,
  DFormRecaptcha,
  DGenresSignupForm,
  DLeaderboardFeed,
  DProfileBadge,
  DProfileBookshelfList,
  DProfileDirectSubmissions,
  DProfileExpandableBiography,
  DReviewerDirectory,
  DSignupButton,
  DStickyMenu,
  DStickyMenuSaveToLibrary,
  DTopMenuContainer,
  DTrackingLink,
  DUserLinkPopup,
};
